const giftBoxDrawer = () => ({
  note: '',
  isPosting: false,

  get giftBoxDrawerCTAText() {
    if (this.isPosting) {
      return 'Working...';
    }

    return this.$store.cart.giftBoxItemOnCart ? 'Update Note' : 'Add Gift Box';
  },

  async upsertGiftBox() {
    const { giftBoxProductData } = this.$store.cart;
    try {
      this.isPosting = true;
      await this.$store.cart.updateCart({
        attributes: {
          'gift-wrapping': 'yes',
          'gift-note': this.note,
        },
      });

      if (!this.$store.cart.giftBoxItemOnCart) {
        await this.$store.cart.addToCart({
          items: [
            {
              id: giftBoxProductData.variants[0].id.replace(
                'gid://shopify/ProductVariant/',
                ''
              ),
              quantity: 1,
            },
          ],
        });
      }
      this.closeGiftBoxDrawer();
      this.note = '';
    } catch {
      alert('Sorry, there was an error updating your cart gift box.');
    } finally {
      this.isPosting = false;
    }
  },

  editGiftBoxNote({ target, detail: giftBoxNote }) {
    if (!target.closest('.cart').contains(this.$root)) return;
    this.note = typeof giftBoxNote === 'string' ? giftBoxNote : '';
    this.openGiftBoxDrawer();
  },

  openGiftBoxDrawer(e) {
    if (e && !e.target.closest('.cart').contains(this.$root)) return;

    this.$root.closest('dialog').showModal();
  },

  closeGiftBoxDrawer() {
    this.$root.closest('dialog').close();
    this.note = '';
  },

  closeCartOrGiftBoxDrawer() {
    if (this.closeCart) return this.closeCart();
    this.closeGiftBoxDrawer();
  },
});

export default giftBoxDrawer;
